/* Progressive enhancement: real links, native overflow, and catalog work without JS. */
(() => {
  if (customElements.get('pr-collection-world')) return;
  class CollectionWorld extends HTMLElement {
    static selectCards(cards, category, sort) {
      const selected = cards.filter(card => category === 'all' || card.dataset.category === category);
      return selected.slice().sort((a, b) => sort === 'price-up' ? Number(a.dataset.price) - Number(b.dataset.price) : sort === 'price-down' ? Number(b.dataset.price) - Number(a.dataset.price) : Number(a.dataset.order) - Number(b.dataset.order));
    }
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const setRail = this.querySelector('#prw-set-rail');
      const jumps = this.querySelector('[data-set-jumps]');
      if (setRail && jumps) {
        jumps.replaceChildren();
        [...setRail.children].forEach((card, index) => {
          const people = Number(card.dataset.persons);
          const pieces = Number(card.dataset.pieces);
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = people > 0 ? `${people} Pers.` : pieces > 0 ? `${pieces} Teile` : `Set ${index + 1}`;
          button.setAttribute('aria-label', people > 0 ? `Set für ${people} Personen ansehen` : pieces > 0 ? `Set mit ${pieces} Teilen ansehen` : `Set ${index + 1} ansehen`);
          const saleBadge = card.querySelector('[data-sale-badge]');
          const rate = saleBadge && !saleBadge.hidden ? saleBadge.textContent.match(/(\d+)\s*%/) : null;
          if (rate) {
            const badge = document.createElement('span');
            badge.className = 'prw-set-jumps__discount';
            badge.textContent = `${rate[1]} %`;
            button.append(badge);
            button.setAttribute('aria-label', `${button.getAttribute('aria-label')} · ${rate[1]} % Set-Vorteil`);
          }
          button.setAttribute('aria-controls', setRail.id);
          button.addEventListener('click', () => {
            const delta = card.getBoundingClientRect().left - setRail.getBoundingClientRect().left;
            setRail.scrollBy({ left: delta, behavior: reduced() ? 'instant' : 'smooth' });
          }, options);
          jumps.append(button);
        });
        jumps.hidden = false;
      }
      this.querySelectorAll('[data-rail-controls]').forEach(controls => {
        const rail = this.querySelector('#' + controls.dataset.railControls);
        if (!rail) return;
        const buttons = [...controls.querySelectorAll('button')];
        const update = () => {
          controls.hidden = rail.scrollWidth <= rail.clientWidth + 2;
          buttons[0].disabled = rail.scrollLeft <= 2;
          buttons[1].disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        };
        const move = direction => {
          const card = rail.firstElementChild;
          const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : rail.clientWidth;
          rail.scrollBy({ left: step * direction, behavior: reduced() ? 'instant' : 'smooth' });
        };
        buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), options));
        rail.addEventListener('keydown', event => {
          if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        rail.addEventListener('scroll', update, { ...options, passive: true });
        window.addEventListener('resize', update, options);
        update();
      });
      const grid = this.querySelector('[data-catalog-grid]');
      if (!grid) return;
      const cards = [...grid.querySelectorAll('[data-world-card]')];
      cards.forEach((card, index) => { card.dataset.order = index; });
      const filters = [...this.querySelectorAll('[data-filter]')];
      const sort = this.querySelector('[data-sort]');
      let category = 'all';
      let visibleLimit = cards.length;
      const more = this.querySelector('[data-more]');
      const update = () => {
        const selected = CollectionWorld.selectCards(cards, category, sort.value);
        const visible = selected.slice(0, visibleLimit);
        cards.forEach(card => { card.hidden = !visible.includes(card); });
        selected.forEach((card, index) => {
          if (grid.children[index] !== card) grid.insertBefore(card, grid.children[index] || null);
        });
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
        this.querySelector('[data-results]').textContent = visible.length < selected.length ? `${visible.length} von ${selected.length} Artikeln` : `${selected.length} Artikel`;
        this.querySelector('[data-empty]').hidden = selected.length > 0;
        more.hidden = visibleLimit >= selected.length;
      };
      filters.forEach(button => {
        const key = button.dataset.filter;
        if (key !== 'all' && !cards.some(card => card.dataset.category === key)) button.hidden = true;
        button.addEventListener('click', () => { category = key; visibleLimit = cards.length; update(); }, options);
      });
      // Keep the selected card in place until the shopper changes a list control.
      sort.addEventListener('change', () => { visibleLimit = cards.length; update(); }, options);
      more.addEventListener('click', () => {
        const selected = CollectionWorld.selectCards(cards, category, sort.value);
        const firstNew = selected[visibleLimit];
        visibleLimit += 8; update();
        firstNew?.querySelector('a')?.focus({ preventScroll: true });
      }, options);
      this.querySelector('[data-catalog-tools]').hidden = false;
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  }
  customElements.define('pr-collection-world', CollectionWorld);
})();
